const ACCIDENTALS = [
  { value: '#', label: '샵', symbol: '♯' },
  { value: '##', label: '더블샵', symbol: '𝄪' },
  { value: 'b', label: '플랫', symbol: '♭' },
  { value: 'bb', label: '더블플랫', symbol: '𝄫' },
  { value: 'n', label: '내추럴', symbol: '♮' },
]

/**
 * 임시표 선택 패드. 음표가 선택돼 있으면 그 자리에 바로 적용하고,
 * 선택된 음표가 없으면 다음에 입력할 음에 적용할 임시표를 "무장"해 둔다
 * (같은 버튼을 다시 누르면 해제).
 */
export default function AccidentalSelector({ value, onChange }) {
  return (
    <div className="duration-selector accidental-selector">
      <span className="dur-label">임시표</span>
      <div className="dur-section">
        {ACCIDENTALS.map(a => (
          <button
            key={a.value}
            type="button"
            className={`dur-btn ${value === a.value ? 'active' : ''}`}
            onClick={() => onChange(value === a.value ? '' : a.value)}
            title={`${a.label} — 음표 선택 중이면 바로 적용, 아니면 다음 입력에 적용`}
          >
            <span className="dur-symbol" aria-hidden>{a.symbol}</span>
            <span className="dur-name">{a.label}</span>
          </button>
        ))}
      </div>
    </div>
  )
}
